const heroSections = [
  {
    page: '/',
    backgroundImage: require('../assets/Hero-bg-Image.png'),
    title: 'Autochef',
    description: 'At The Auto Chef, we blend meticulous craftsmanship with innovative techniques to transform your vehicle into a masterpiece. Specializing in high-end automobile restoration and facelifts, our expert team ensures every detail is perfected.',
  },
  {
    page: '/about',
    backgroundImage: require('../assets/Hero-bg-Image.png'),
    title: 'About Us',
    description: 'We are dedicated to providing the best service and value for our customers.',
  },
  {
    page: '/services',
    backgroundImage: require('../assets/Hero-bg-Image.png'),
    title: 'Our Services',
    description: 'At AutoChef, we are committed to providing exceptional service and high-quality workmanship. Contact us today to schedule an appointment and experience the AutoChef difference.',
    description2: 'At AutoChef, we provide a comprehensive range of auto repair and maintenance services to keep your vehicle running smoothly and looking its best. Explore our specialized services below:',
  },
  {
    page: '/gallery',
    backgroundImage: require('../assets/Hero-bg-Image.png'),
    title: 'Gallery',
    description: 'Take a look at our recent projects and achievements.',
  },
  {
    page: '/contact',
    backgroundImage: require('../assets/Hero-bg-Image.png'),
    title: 'Contact Us',
    description: 'Get in touch with us for any queries or to schedule an appointment.',
  },
  // {
  //   page: '/booking',
  //   backgroundImage: require('../assets/Hero-bg-Image.png'),
  //   title: 'Book an Appointment',
  //   description: 'Schedule your appointment with our expert team today.',
  // },
  {
    page: '/reviews',
    backgroundImage: require('../assets/Hero-bg-Image.png'),
    title: 'Customer Reviews',
    description: 'Read what our customers have to say about our services.',
  },
];

export default heroSections;
